import { Instance } from 'mobx-state-tree';
import CollectionMapProcessor from '~/mst/models/abstract/collection_map_processor';
import model from './model';
import actions from './actions';
import views from './views';

const UsersStore = model.views(views).actions(actions);

export interface IUsersStore extends Instance<typeof UsersStore> {}

export default CollectionMapProcessor(UsersStore);
